import React from 'react';
import { Button } from '@core/js/components/common/Button';

import * as Types from './../../types';
import { ACTIVE_TAB_POPUP } from './../../constants';

import style from './CookieButtons.scss';

export const CookieButtons: React.FC<Types.ICookieButtonsProps> = ({
    activeTab,
    translate,
    handleSubmitCookieSettings,
    handleAccept,
    setActiveTab
}) => {
    const buttonsConfig = [
        {
            isShow: activeTab === ACTIVE_TAB_POPUP.SETTING,
            onClick: handleSubmitCookieSettings,
            className: style.acceptSettingsBtn,
            label: 'acceptSettingsBtn'
        },
        {
            isShow: activeTab === ACTIVE_TAB_POPUP.MESSAGE,
            onClick: () => setActiveTab(ACTIVE_TAB_POPUP.SETTING),
            className: style.navigateBtn,
            label: 'navigateToSettings'
        },
        {
            isShow: true,
            onClick: handleAccept,
            className: style.acceptBtn,
            label: 'acceptBtn',
            extraProps: { color: 'success', view: 'secondary' }
        }
    ];

    return (
        <div className={style.buttons}>
            {buttonsConfig.map((button, index) => {
                const { isShow, extraProps = {}, ...buttonProps } = button;
                return (
                    isShow && <Button
                        key={index}
                        type="button"
                        size="medium"
                        {...extraProps}
                        {...buttonProps}
                        className={`${style.button} ${button.className}`}
                    >
                        {translate(button.label)}
                    </Button>
                );
            })}
        </div>
    );
};
